export default {
  companyProfileMetadata: {
    editCompanyTitle: 'Edit profile',
    changeCompanyAboutTitle: 'Edit the company description',
    aboutCompany: 'Tell us about the company',
    companyDashboardTitle: 'Employee profile settings',
    companyDashboardDescription: 'You can change the visibility of the blocks on the staff page.',
    companyDashboardCaption: 'These blocks are selected',
    noBlocksSelected: 'No blocks selected',
    changeDashboardTitle: 'Configure the visibility of blocks',
    deleteManagerTitle: 'Remove an employee from the list of managers?',
    deleteManagerButton: 'Yes, remove',
    managersNotSpecified: 'Managers not specified',
    addManagers: 'Add a managers',
    changeManager: 'Change the manager',
    selectModules: 'Select modules',
    removeFromOrganizersTitle: 'Remove an employee from the list of organizers?',
    removeFromOrganizersButton: 'Yes, remove',
    organizersNotSpecified: 'Organizers not specified',
    deletePortfolioTitle: 'Delete the portfolio item?',
    changeServicesTitle: 'Edit the services',
    nameServices: 'Enter the name of the service',
    // messages
    successMessages: {
      editCompany: 'The company description has been successfully changed',
      saveSettings: 'Configuration successfully saved',
      deleteManager: 'The employee was successfully removed from the list of managers',
      editManagers: 'The list of managers successfully changed',
      removeFromOrganizers: 'The employee was successfully removed from the list of organizers',
      editOrganizers: 'The list of organizers successfully changed',
      deletePortfolio: 'The portfolio item has been successfully deleted',
      changeServices: 'Services changed successfully',
    },
    errorMessages: {
      editCompany: 'Failed to change the company description',
      saveSettings: 'Failed to save configuration',
      deleteManager: 'Failed to remove the employee from the list of managers',
      editManagers: 'Failed to change the list of managers',
      removeFromOrganizers: 'Error when deleting an employee from the list of organizers',
      editOrganizers: 'Failed to change the list of organizers',
      deletePortfolio: 'Failed to delete portfolio item',
      changeServices: 'Failed to change services',
    },
    //
  },
};
